export const environment = {
    production: true,
    api: 'https://dev.api.classichub.co.nz',
    buildVersion: '2026.3.4.5',
    uri: 'https://dev.classichub.co.nz',
    envName: 'dev',
    isTest: true,
};

